"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureValueDtoTypeEnum = void 0;
exports.instanceOfFeatureValueDto = instanceOfFeatureValueDto;
exports.FeatureValueDtoFromJSON = FeatureValueDtoFromJSON;
exports.FeatureValueDtoFromJSONTyped = FeatureValueDtoFromJSONTyped;
exports.FeatureValueDtoToJSON = FeatureValueDtoToJSON;
exports.FeatureValueDtoToJSONTyped = FeatureValueDtoToJSONTyped;
var FeatureValueDtoValue_1 = require("./FeatureValueDtoValue");
/**
 * @export
 */
exports.FeatureValueDtoTypeEnum = {
    Boolean: 'boolean',
    Numeric: 'numeric',
    String: 'string'
};
/**
 * Check if a given object implements the FeatureValueDto interface.
 */
function instanceOfFeatureValueDto(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('value' in value) || value['value'] === undefined)
        return false;
    return true;
}
function FeatureValueDtoFromJSON(json) {
    return FeatureValueDtoFromJSONTyped(json, false);
}
function FeatureValueDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'value': (0, FeatureValueDtoValue_1.FeatureValueDtoValueFromJSON)(json['value']),
    };
}
function FeatureValueDtoToJSON(json) {
    return FeatureValueDtoToJSONTyped(json, false);
}
function FeatureValueDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'value': (0, FeatureValueDtoValue_1.FeatureValueDtoValueToJSON)(value['value']),
    };
}
